import { Channel, CreateMixin } from '@rails/actioncable';

import { ClassList } from '@gmm/sdk-voodoo/classes';
import { getEmptyArray } from '~/lib/type-utils';
import { useActionCable } from '~/lib/webSocket';

import { useGetClassList } from './useGetClassList';

export const useTeacherNotifications = <M extends CreateMixin>(
  handlers: M = {} as M,
): Channel<M> => {
  const { activeClasses = getEmptyArray<ClassList>() } = useGetClassList();
  const classIds = activeClasses.map(({ id }) => id);
  const channelConfig = { channel: 'TeacherKlassesChannel', classIds };

  useActionCable(
    {
      channel: 'TeacherChannel',
    },
    handlers,
  );

  return useActionCable(channelConfig, handlers);
};
